<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas20bg.svg" />

    <p id="tag01" class="textBase basicItem01 tagDefault">Porfiado</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">Muy astuto</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">Obediente</p>
    <p id="tag04" class="textBase basicItem01 tagDefault">Buen hermano</p>
    <p id="tag05" class="textBase basicItem01 tagDefault">Desobediente</p>
    <p id="tag06" class="textBase basicItem01 tagDefault">Le gusta engañar</p>
    <p id="tag07" class="textBase basicItem01 tagDefault">Inteligente</p>
    <p id="tag08" class="textBase basicItem01 tagDefault">
      Defiende a los animales
    </p>
    <p id="tag09" class="textBase basicItem01 tagDefault">Valiente</p>

    <span class="normalTheme pageInstruction" style="left: 27px; top: 410px">
      <p>Escribe sólo las expresiones que describen a Serafín.</p>
    </span>

    <span
      style="
        outline: 1px solid #a6a6a6;
        width: 759px;
        height: 290px;
        left: 65px;
        top: 455px;
        z-index: 2;
        position: absolute;
      "
    ></span>
    <saved-input-long
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      maxlength="250"
      style="line-height: 74px"
      placeholder="Valiente, "
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 41px;
  top: 37px;
  z-index: -1;
}

#inputField01 {
  position: absolute;
  width: 729px;
  height: 290px;
  left: 35px;
  top: 435px;
  margin-left: 50px;
  margin-top: 10px;
  font-size: 33px;
  font-family: "Courier New", Courier, monospace;
  font-weight: bold;
  color: #2bb673;
  z-index: 10;
}

#tag01 {
  position: absolute;
  width: 210px;
  text-align: center;
  left: 14px;
  top: 148px;
}
#tag02 {
  position: absolute;
  width: 210px;
  text-align: center;
  left: 256px;
  top: 148px;
}
#tag03 {
  position: absolute;
  width: 210px;
  text-align: center;
  left: 499px;
  top: 148px;
}
#tag04 {
  position: absolute;
  width: 270px;
  text-align: center;
  left: 742px;
  top: 148px;
}
#tag05 {
  position: absolute;
  width: 240px;
  text-align: center;
  left: 17px;
  top: 227px;
}
#tag06 {
  position: absolute;
  width: 370px;
  text-align: center;
  left: 305px;
  top: 227px;
}
#tag07 {
  position: absolute;
  width: 210px;
  text-align: center;
  left: 745px;
  top: 227px;
}
#tag08 {
  position: absolute;
  width: 430px;
  text-align: center;
  left: 145px;
  top: 310px;
}
#tag09 {
  position: absolute;
  width: 210px;
  text-align: center;
  left: 636px;
  top: 310px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 55.mp4",
        "cas/Video 56.mp4",
        "cas/Video 57.mp4",
        "cas/Video 58.mp4",
        "cas/Video 59.mp4",
        "cas/Video 60.mp4",
        "cas/Video 61.mp4",
        "cas/Video 62.mp4",
        "cas/Video 63.mp4",
        "cas/Video 64.mp4",
        "cas/Video 65.mp4",
      ],
    };
  },
};
</script>